module.exports = __webpack_public_path__ + "img/pdf-default.86894df7.jpg";